import { z } from 'zod';
import { requiredMsg, integerMsg, maxStringMsg, minArrayMsg } from '@/constants';

export const orderRezeptSheetDetailSchema = z
  .object({
    id: z.number().nullable().optional(),
    rezept_sheet_id: z.number().int().positive().nullable().optional(),
    quantity: z
      .string()
      .min(1, { message: requiredMsg('数量') })
      .refine(v => /^-?\d+$/.test(v), { message: integerMsg('数量') })
      .optional()
      .default(''),
    delivery_fee: z
      .string()
      .refine(v => !v || /^-?\d+$/.test(v), { message: integerMsg('送料') })
      .optional()
      .default(''),
    is_include_case: z.boolean().optional().default(false),
    request_delivery_date: z.string().nullable().optional(),
    ship_date: z.string().nullable().optional(),
    remarks: z.string().max(225, maxStringMsg('備考', 225)).nullable().optional(),
    is_delete: z.boolean().optional().default(false),
  })
  .superRefine((data, ctx) => {
    // 用紙名: required
    if (data.rezept_sheet_id == null || data.rezept_sheet_id <= 0) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: requiredMsg('用紙名'),
        path: ['rezept_sheet_id'],
      });
    }

    // 出荷日 must not be before 納品希望日 (cross-field validation only)
    if (
      data.ship_date &&
      data.request_delivery_date &&
      data.ship_date < data.request_delivery_date
    ) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: '出荷日は納品希望日より後の日時を指定してください。',
        path: ['ship_date'],
      });
    }
  });

export const orderRezeptSheetEditSchema = z.object({
  details: z.array(orderRezeptSheetDetailSchema).min(1, minArrayMsg('明細データ', 1)),
});

export type OrderRezeptSheetDetailFormData = z.infer<typeof orderRezeptSheetDetailSchema>;
export type OrderRezeptSheetEditFormData = z.infer<typeof orderRezeptSheetEditSchema>;
